module.exports = __webpack_public_path__ + "img/con2.790e2622.png";